<style scoped lang="less">
@import "../../less/colors";

.modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 9999999;
    background-color: rgba(0, 0, 0, 0.5);

    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    padding: 2rem;

    &.show {
        visibility: visible;
        opacity: 1;
        pointer-events: auto;
    }

    .modal-content {
        height: 100%;
    }
}


</style>

<template>
    <div class="modal-window" :class="{show: showPopup}" @click.self="close()">
        <div class="modal-content" ref="modal-content">
            <slider-base :images="images" :bus="bus" :showControls="true" :allowKeys="true" type="contain" @indexChanged="currentIndex = $event" @clickedOutside="close()" @close="close()"></slider-base>
        </div>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                showPopup: false,
                currentIndex: null,
            };
        },

        props: {
            images: Array,
            bus: Object,
        },

        mounted() {
            this.bus.$emit('setClient', this.$refs['modal-content']);
            this.bus.$on('show', this.show);
        },

        methods: {

            show(index) {
                this.currentIndex = index;
                this.showPopup = true;
                document.documentElement.style.overflow = 'hidden';
            },

            close() {
                this.showPopup = false;
                document.documentElement.style.overflow = 'auto';
            },

        },
    }
</script>
